import { SETTINGS_PREFIX } from '#pplx/frontend/apps/ask/settings/constants.js';
export const useGetSettingsRoute = () => {
    return `${SETTINGS_PREFIX}/details`;
};
export const useGetSettingsPrefix = () => SETTINGS_PREFIX;
//# sourceMappingURL=useGetSettingsRoute.js.map